export const MULTIPLE_SEARCHES_BUTTONS = ['Heatmap', 'Network'];
export const SINGLE_SEARCHES_BUTTONS = ['Line', 'Network'];

export function areSearchesMultiple(names: string, title: string, ident: string): boolean {
  return names.length > 1 || (names.length === 1 && title === 'SummaryVDA' && ident === 'GENES');
}

export function getAvailableCharts(names: string, title: string, ident: string): string[] {
  return areSearchesMultiple(names, title, ident)
    ? MULTIPLE_SEARCHES_BUTTONS
    : SINGLE_SEARCHES_BUTTONS;
}

export function getViewToggleText(currentView: string): string {
  return currentView === 'tables' ? 'Graphs' : 'Tables';
}
